// Instagram Images Configuration for King Bistro Grille
// Replace these placeholder URLs with actual Instagram image URLs from @kingbistrogrille

export const instagramImages = {
  // Hero Images
  hero: {
    main: "/images/instagram/hero-main.jpg", // Main restaurant ambiance
    background: "/images/instagram/hero-background.jpg", // Restaurant interior
  },

  // Menu Items - Appetizers
  appetizers: {
    truffleArancini: "/images/instagram/truffle-arancini.jpg",
    burrataCaprese: "/images/instagram/burrata-caprese.jpg",
    lobsterBisque: "/images/instagram/lobster-bisque.jpg",
    bruschetta: "/images/instagram/bruschetta.jpg",
    calamari: "/images/instagram/calamari.jpg",
  },

  // Menu Items - Main Courses
  mainCourses: {
    wagyuBeef: "/images/instagram/wagyu-beef.jpg",
    seaBass: "/images/instagram/sea-bass.jpg",
    duckConfit: "/images/instagram/duck-confit.jpg",
    trufflePasta: "/images/instagram/truffle-pasta.jpg",
    grilledSalmon: "/images/instagram/grilled-salmon.jpg",
    beefTenderloin: "/images/instagram/beef-tenderloin.jpg",
  },

  // Menu Items - Desserts
  desserts: {
    chocolateSouffle: "/images/instagram/chocolate-souffle.jpg",
    cremeBrulee: "/images/instagram/creme-brulee.jpg",
    tiramisu: "/images/instagram/tiramisu.jpg",
    lavaCake: "/images/instagram/lava-cake.jpg",
  },

  // Beverages
  beverages: {
    chateauMargaux: "/images/instagram/chateau-margaux.jpg",
    domPerignon: "/images/instagram/dom-perignon.jpg",
    oldFashioned: "/images/instagram/old-fashioned.jpg",
    cocktails: "/images/instagram/cocktails.jpg",
  },

  // Restaurant & Ambiance
  restaurant: {
    interior: "/images/instagram/restaurant-interior.jpg",
    exterior: "/images/instagram/restaurant-exterior.jpg",
    bar: "/images/instagram/bar.jpg",
    dining: "/images/instagram/dining-area.jpg",
    kitchen: "/images/instagram/kitchen.jpg",
  },

  // Team Photos
  team: {
    chefMichael: "/images/instagram/chef-michael.jpg",
    sarahChen: "/images/instagram/sarah-chen.jpg",
    davidRodriguez: "/images/instagram/david-rodriguez.jpg",
  },

  // Food Photography
  food: {
    plating: "/images/instagram/food-plating.jpg",
    ingredients: "/images/instagram/ingredients.jpg",
    cooking: "/images/instagram/cooking-process.jpg",
    presentation: "/images/instagram/food-presentation.jpg",
  },

  // Events & Special Occasions
  events: {
    privateDining: "/images/instagram/private-dining.jpg",
    celebrations: "/images/instagram/celebrations.jpg",
    winePairing: "/images/instagram/wine-pairing.jpg",
  },
};

// Fallback to Unsplash images if Instagram images are not available
export const fallbackImages = {
  hero: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
  truffleArancini:
    "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  burrataCaprese:
    "https://images.unsplash.com/photo-1551248429-40975aa4de74?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  lobsterBisque:
    "https://images.unsplash.com/photo-1547592166-23ac45744acd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  wagyuBeef:
    "https://images.unsplash.com/photo-1546833999-b9f581a1996d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  seaBass:
    "https://images.unsplash.com/photo-1467003909585-2f8a72700288?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  duckConfit:
    "https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  trufflePasta:
    "https://images.unsplash.com/photo-1621996346565-e3dbc353d2e5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  chocolateSouffle:
    "https://images.unsplash.com/photo-1565958011703-44f9829ba187?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  cremeBrulee:
    "https://images.unsplash.com/photo-1551024506-0bccd828d307?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  tiramisu:
    "https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  chateauMargaux:
    "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  domPerignon:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  oldFashioned:
    "https://images.unsplash.com/photo-1470337458703-46ad1756a187?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  chefMichael:
    "https://images.unsplash.com/photo-1577219491135-ce391730fb2c?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
  sarahChen:
    "https://images.unsplash.com/photo-1581299894007-aaa50297cf16?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
  davidRodriguez:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
  kitchen:
    "https://images.unsplash.com/photo-1559339352-11d035aa65de?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
};

// Helper function to get image with fallback
export const getImage = (
  instagramPath: string,
  fallbackUrl: string
): string => {
  // For now, return fallback. When you add Instagram images, change this logic
  return fallbackUrl;

  // When you have Instagram images, uncomment this:
  // try {
  //   // Check if Instagram image exists
  //   return instagramPath;
  // } catch {
  //   return fallbackUrl;
  // }
};
